// The setup watch survives a reload: a mid-build refresh resumes the wait (with elapsed
// time honoured) instead of the card offering an Open link into a half-built instance.
// Cleared on dismiss; ignored and cleared once stale. Fails open if storage is
// unavailable — the wait just won't survive a reload.
const KEY = 'eh.setupWatch';

// orgId scopes the watch: on a shared browser, one org's build wait must never
// resurface for a different org signed in on the same machine.
export type StoredSetupWatch = { orgId: string; productKey: string; startedAt: number };

export function saveSetupWatch(watch: StoredSetupWatch): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(watch));
  } catch {
    /* ignore — see note above */
  }
}

export function loadSetupWatch(): StoredSetupWatch | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    const watch = parsed as Partial<StoredSetupWatch>;
    return typeof watch?.orgId === 'string' &&
      typeof watch?.productKey === 'string' &&
      typeof watch?.startedAt === 'number'
      ? { orgId: watch.orgId, productKey: watch.productKey, startedAt: watch.startedAt }
      : null;
  } catch {
    return null;
  }
}

export function clearSetupWatch(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
